const PonyRoomEvent = {
  PhSettings: 'pony.house.settings', // Room Event
};

export default PonyRoomEvent;
